import Select from 'react-select';
import 'react-select/dist/react-select.css';
import {connect} from 'react-redux';

import React, {Component} from 'react';
import {actions} from 'react-redux-form';

class DropDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value
    };
  }

  componentDidMount() {
    const {model, dispatch} = this.props;

    dispatch(actions.change(model, this.props.value.value));
    this.setState({value: this.props.value});
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.value !== nextProps.value) {
      this.setState({value: nextProps.value});
    }
  }

  handleChange(val) {
    const {model, dispatch} = this.props;
    this.setState({value: val}, () => {
      if (val === null) {
        dispatch(actions.change(model, ''));
      } else {
        dispatch(actions.change(model, val.value));
      }

      if (typeof this.props.onChange === 'function') {
        this.props.onChange(val);
      }
    });
  }

  render() {
    const {data, placeholder} = this.props;
    const searchable = this.props.searchable || false;
    return (
      <Select
        className={this.props.className || ''}
        multi={false}
        onChange={option => this.handleChange(option)}
        options={data}
        placeholder={placeholder}
        searchable={searchable}
        value={this.state.value}
      />
    );
  }
}

export default connect()(DropDown);



// WEBPACK FOOTER //
// ./src/components/common/form/dropdown.jsx